module.exports = __webpack_public_path__ + "static/media/Misconduct.33b24fe2.png";